<template>
  <auth-summary>
    E-Mail-Adresse: <strong>{{ state.value.username }}</strong>
  </auth-summary>
</template>

<script>
import AuthSummary from "@/components/plenigo-auth-v2/components/auth-summary";
export default {
  components: { AuthSummary },
  props: {
    state: Object
  }
};
</script>
